const eventListeners = {};

const TYPE = {
  INQUIRY_DELETED: 'INQUIRY_DELETED',
  ORDER_DELETED: 'ORDER_DELETED',
  ORDER_FINALIZED: 'ORDER_FINALIZED',
  ORDER_CHANGED: 'ORDER_CHANGED',
  ORDER_CONFIRMED_ERROR: 'ORDER_CONFIRMED_ERROR',
  ORDER_CLEARED: 'ORDER_CLEARED',
  NEW_ORDER: 'NEW_ORDER',
  INVENTORY_CHANGED: 'INVENTORY_CHANGED',
  IDENTITY_CHANGED: 'IDENTITY_CHANGED',
  SHOW_REQUEST_IDENTITY_MODAL: 'SHOW_REQUEST_IDENTITY_MODAL',
  SHOW_REQUEST_IDENTITY_CHAT: 'SHOW_REQUEST_IDENTITY_CHAT',
  HIDE_REQUEST_IDENTITY_MODAL: 'HIDE_REQUEST_IDENTITY_MODAL',
  SHOW_RESELL_BAR: 'SHOW_RESELL_BAR',
  HIDE_RESELL_BAR: 'HIDE_RESELL_BAR',
  INQUIRY_ITEMS_UPDATE_STACK_CHANGED: 'INQUIRY_ITEMS_UPDATE_STACK_CHANGED',
  SHOW_CHAT_NOW_POPOVER: 'SHOW_CHAT_NOW_POPOVER',
  HIDE_CHAT_NOW_POPOVER: 'HIDE_CHAT_NOW_POPOVER',
  SHOW_SUBSCRIBE_MODAL: 'SHOW_SUBSCRIBE_MODAL',
  HIDE_SUBSCRIBE_MODAL: 'HIDE_SUBSCRIBE_MODAL',
  CONFIRM_DELETE_ACCOUNT: 'CONFIRM_DELETE_ACCOUNT',
  SHOW_ADDRESS_PICKER: 'SHOW_ADDRESS_PICKER',
  HIDE_ADDRESS_PICKER: 'HIDE_ADDRESS_PICKER',
  SHOW_CUSTOMER_SEARCH: 'SHOW_CUSTOMER_SEARCH',
  HIDE_CUSTOMER_SEARCH: 'HIDE_CUSTOMER_SEARCH',
  SHOW_LIST_SEARCH_PICKER: 'SHOW_LIST_SEARCH_PICKER',
  HIDE_LIST_SEARCH_PICKER: 'HIDE_LIST_SEARCH_PICKER',
  ROUTE_CHANGE: 'ROUTE_CHANGE',
  MANDATORY_LOGIN_DONE: 'MANDATORY_LOGIN_DONE',
  SIZE_GUIDE_MODAL: 'SIZE_GUIDE_MODAL',
  WINDOW_FOCUSED: 'WINDOW_FOCUSED',
  WINDOW_BLURRED: 'WINDOW_BLURRED',
  CLEAR_AMALGAM: 'CLEAR_AMALGAM',
  OPTIONS_MODAL: 'OPTIONS_MODAL',
  SHIPPING_ADDRESS_CHANGED: 'SHIPPING_ADDRESS_CHANGED',
  FETCH_SHIPPING_DETAILS_UPDATED: 'FETCH_SHIPPING_DETAILS_UPDATED',
  SELECTED_SHIPPING_MODE_CHANGED: 'SELECTED_SHIPPING_MODE_CHANGED',
  NAVBAR_HEIGHT_CHANGED: 'NAVBAR_HEIGHT_CHANGED',
  SEARCH_RESULTS_SAVED: 'SEARCH_RESULTS_SAVED',
  AMALGAM_PAGE_FETCHED: 'AMALGAM_PAGE_FETCHED',
  SELECTED_TAG_CHANGED: 'SELECTED_TAG_CHANGED',
  INITIAL_SEARCH_TAGS_FILTER_DONE: 'INITIAL_SEARCH_TAGS_FILTER_DONE',
  CLEAR_FILTER: 'CLEAR_FILTER',
  TAG_FILTERING_STARTED: 'TAG_FILTERING_STARTED',
  TAG_FILTERING_DONE: 'TAG_FILTERING_DONE',
  CLEAR_FILTER_STARTED: 'CLEAR_FILTER_STARTED',
  CLEAR_FILTER_DONE: 'CLEAR_FILTER_DONE',
  SEARCH_STARTED: 'SEARCH_STARTED',
  SEARCH_DONE: 'SEARCH_DONE',
  SEARCH_TERM_CHANGED: 'SEARCH_TERM_CHANGED',
  CUSTOMER_CHANGED: 'CUSTOMER_CHANGED',
  CHECKOUT_FIELD_CHANGED: 'CHECKOUT_FIELD_CHANGED',
  CATALOGUE_FILTERS_CHANGED: 'CATALOGUE_FILTERS_CHANGED',
  CATALOGUE_FILTERS_CHANGED_DONE: 'CATALOGUE_FILTERS_CHANGED_DONE',
  SELECTED_TAG_FILTER_CHANGED: 'SELECTED_TAG_FILTER_CHANGED',
  RESET_CATALOGUE_FILTERS: 'RESET_CATALOGUE_FILTERS',
  CLEAR_FILTER_ON_CATALOGUE_UNMOUNT: 'CLEAR_FILTER_ON_CATALOGUE_UNMOUNT',
  SELECTED_PAYMENT_TYPE_CHANGE: 'SELECTED_PAYMENT_TYPE_CHANGE',
  ORDER_ENTITY_UPDATE: 'ORDER_ENTITY_UPDATE',
  ON_LOGIN: 'ON_LOGIN',
  FETCH_VARIANT_META_STARTED: 'FETCH_VARIANT_META_STARTED',
  FETCH_VARIANT_META_ENDED: 'FETCH_VARIANT_META_ENDED',
  VIDEO_MODAL_VISIBILITY_CHANGED: 'VIDEO_MODAL_VISIBILITY_CHANGED',
  CLEAR_SINGLE_PAGE_VIRTUOSO_CACHE: 'CLEAR_SINGLE_PAGE_VIRTUOSO_CACHE',
  FOCUS_NAVBAR_SEARCH: 'FOCUS_NAVBAR_SEARCH'
};

const addListener = (type, listener) => {
  if (!eventListeners[type]) {
    eventListeners[type] = [];
  }

  eventListeners[type].push(listener);
};

const removeListener = (type, listener) => {
  if (!eventListeners[type] || !eventListeners[type].length) {
    return;
  }

  const pos = eventListeners[type].indexOf(listener);

  eventListeners[type].splice(pos, 1);
};

const notify = (type, data) => {
  if (!eventListeners[type] || !eventListeners[type].length) {
    return;
  }

  eventListeners[type].forEach((listener) => {
    listener(data);
  });
};

export default {
  TYPE,
  addListener,
  removeListener,
  notify
};
